import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'letter-x-small', 'IconLetterXSmall', [["path",{"d":"M10 8l4 8","key":"svg-0"}],["path",{"d":"M10 16l4 -8","key":"svg-1"}]]);